import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectAccessTitle: {
		id: 'project-details.project-access-title',
		defaultMessage: 'Access',
		description:
			'The title of the dropdown, which represents the access level, in project details page.',
	},
	downgradedProjectAccessMessage: {
		id: 'project-details.project-access.disabled.message',
		defaultMessage:
			"Permissions aren't editable on the Free plan. Upgrade to customize project permissions.",
		description: 'Explains why the Project access component is disabled in the Project details',
	},
	projectAccessPlaceholder: {
		id: 'project-details.project-access-placeholder',
		defaultMessage: 'Choose an access level',
		description:
			'Placeholder of the dropdown, which represents to choose the access level, in project details page.',
	},
});
